import React from 'react';
import PropTypes from 'prop-types';
import NumberField from 'components/form-components/NumberField';
import crossGreyIcon from 'assets/images/icons/cross-grey.svg';
import ColorChangeDropdown from 'components/common-components/ColorChangeDropdown';
import { useTranslation } from 'react-i18next';

const ValueRanges = ({ name, value, onChange }) => {
  const { t } = useTranslation();
  const ITEM_DEFAULT = { from: '', to: '', color: '#ff0000' };

  const optionList = value.length ? value : [ITEM_DEFAULT];

  const updateList = (newList) => {
    onChange(name, newList);
  };

  const addToList = () => {
    updateList([...optionList, { ...ITEM_DEFAULT }]);
  };

  const removeFromList = (index) => {
    const tempOptionList = [...optionList];
    tempOptionList.splice(index, 1);
    updateList(tempOptionList);
  };

  const handleListChange = (index, fieldName, fieldValue) => {
    const newOptionList = [...optionList];
    newOptionList[index][fieldName] = fieldValue;
    newOptionList[index] = { ...newOptionList[index], [fieldName]: fieldValue };
    updateList(newOptionList);
  };

  return (
    <>
      {optionList.map((option, index) => (
        <div key={index} className='d-flex align-items-end gap-3'>
          <div>
            <label>{t('text_from')}</label>
            <NumberField
              name={'from'}
              value={option.from}
              handleChange={(fieldName, fieldValue) =>
                handleListChange(index, fieldName, fieldValue)
              }
              shrinkFieldOnly
              classes='min-width-160'
            />
          </div>
          <div>
            <label>{t('text_to')}</label>
            <NumberField
              name={'to'}
              value={option.to}
              handleChange={(fieldName, fieldValue) =>
                handleListChange(index, fieldName, fieldValue)
              }
              shrinkFieldOnly
              classes='min-width-160'
            />
          </div>
          <div className='d-flex align-items-center gap-1'>
            <ColorChangeDropdown
              name='item'
              toggleComponent={
                <>
                  <div className='p-2 border-grey-1-h-1 rounded-sm cursor-pointer'>
                    <div
                      className='w-100 h-100 clickable-color-div'
                      style={{ background: option.color }}
                    ></div>
                  </div>
                </>
              }
              toggleClasses='cursor-pointer'
              styleProperties={{
                itemColor: option.color,
              }}
              handleChange={(fieldName, fieldValue) => handleListChange(index, 'color', fieldValue)}
              hideFontSizeOption
            />
            <div className='p-1'>
              <img
                src={crossGreyIcon}
                role='button'
                className={` theme-width-20 ${
                  optionList.length > 1 ? 'cursor-pointer' : 'opacity-50 svg-grey pe-none'
                }`}
                onClick={() => removeFromList(index)}
              />
            </div>
          </div>
        </div>
      ))}

      <div>
        <span
          className='text-nowrap theme-text-green-1 theme-size-1_1 theme-font-inter-medium cursor-pointer'
          onClick={() => addToList()}
        >
          {t('text_add_new_range')}
        </span>
      </div>
    </>
  );
};

ValueRanges.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ValueRanges;
